var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9201 0.333252C12.2001 0.333252 0.253418 12.2799 0.253418 26.9999C0.253418 41.7199 12.2001 53.6666 26.9201 53.6666C41.6401 53.6666 53.5867 41.7199 53.5867 26.9999C53.5867 12.2799 41.6667 0.333252 26.9201 0.333252ZM23.5867 35.0799C23.5867 36.3599 23.0534 36.8666 21.6934 36.8666H18.2267C16.8667 36.8666 16.3334 36.3599 16.3334 35.0799V18.9199C16.3334 17.6399 16.8667 17.1333 18.2267 17.1333H21.6667C23.0267 17.1333 23.5601 17.6399 23.5601 18.9199V35.0799H23.5867ZM37.6667 35.0799C37.6667 36.3599 37.1334 36.8666 35.7734 36.8666H32.3334C30.9734 36.8666 30.4401 36.3599 30.4401 35.0799V18.9199C30.4401 17.6399 30.9734 17.1333 32.3334 17.1333H35.7734C37.1334 17.1333 37.6667 17.6399 37.6667 18.9199V35.0799Z",
    fill: "#F6F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.ad144d0a2db3e9f69d2c865596951706.svg";
export { ForwardRef as ReactComponent };